import React, { FC } from 'react';
import { TDropdownProps } from '../../types/PrivacyStatement.types';

const Dropdown: FC<TDropdownProps> = (props: TDropdownProps) => {
    const { Collection, changeTitle, defaultTitle, onSelect, preSelected} = props;
  
    return (
        <div className='privacy-statement-v2__dropdown-wrapper'>
            <label className='privacy-statement-v2__dropdown-title'>{changeTitle}</label>
            <select className='privacy-statement-v2__dropdown' onChange={(e) => onSelect(e.target.value)}>
                <option value={''} key={`first-val-${changeTitle}`}>{''}</option>
                {
                    Collection.map((val) => {
                        return (
                            <option value={val} key={val} selected={(preSelected === val) || (defaultTitle === val)}>
                                {val}
                            </option>
                        )
                    })
                }
            </select>
        </div>
    )
}

export default Dropdown;
